import { render, staticRenderFns } from "./LinkExplanation.vue?vue&type=template&id=a2b405a8"
import script from "./LinkExplanation.vue?vue&type=script&lang=js"
export * from "./LinkExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports